// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__9ORJn","header":"MessagesList_header__2_O3M","chat":"MessagesList_chat__3SEkS"};